module.exports = __webpack_public_path__ + "static/media/ShopImage.0163960e.png";